import React from 'react';
import { Redirect } from 'react-router-dom';
import i18next from 'i18next';

import { PageTitle } from '../PageTitle';
import { ActionsService } from '../../services';

class ActionView extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      action: null,
      actionId: props.match.params.actionId,
      errorMessage: null
    };
  }

  componentDidMount() {
    ActionsService.get(this.state.actionId).then((response) => {
      this.setState({ action: response.action });
    }).catch((error) => {
      this.setState({ errorMessage: i18next.t('messages.could-not-load-action-view') });
      console.error(error);
    });
    ActionsService.getAssociatedAlertConfigs(this.state.actionId).then(response => {
      this.setState({ alertConfigurations: response.alertConfigurations.filter(ac => ac) });
    }).catch(error => {
      this.setState({ errorMessage: i18next.t('messages.could-not-load-alert-configs') });
      console.error(error);
    });
  }

  render() {
    if (this.state.errorMessage) {
      return (
          <Redirect to={{
            pathname: '/config/actions',
            state: {
              errorMessage: this.state.errorMessage
            }
          }}/>
      );
    }

    if (this.state.action && this.state.alertConfigurations) {
      const backLinkSearch = this.props.location.state && this.props.location.state.backLinkSearch ? this.props.location.state.backLinkSearch : null;
      return <ActionDetail action={this.state.action} alerts = {this.state.alertConfigurations} backLinkSearch={backLinkSearch} />;
    } else {
      return (
          <div className="loader">{i18next.t('loading')}</div>
      );
    }
  }

}

class ActionDetail extends React.Component {
  render() {
    const actionResultRows = this.props.action.actionResults
            .filter(actionResult => !actionResult.archived)
            .map(actionResult => <ActionResultRow key={actionResult.id} actionResult={actionResult} />);
    let alerts = this.props.alerts.map((alert,index) =>  <p key = {index}>{alert.name}</p>)

    return (
      <div>
        <div className="row">
          <PageTitle 
            title={this.props.action.name}
            editLinkWithParams={{
              link: {
                pathname: `/config/actions/edit/${this.props.action.id}`,
                uiroute: '/config/actions/edit/:actionId',
                state: {
                  backLinkSearch: this.props.backLinkSearch
                }
              }
            }}
            backLinkWithParams={{
              link: {
                pathname: '/config/actions',
                search: this.props.backLinkSearch
              }
            }}
          />
        </div>

        <div className="op-content-box">
          <div className="row">
            <div className="col-sm-6 form-group">
              <div className="card-data-cell remove-border-left card-data-cell-icon card-icon-description">
                <label>{i18next.t('form-labels.description')}:</label>
                <p>{this.props.action.description}</p>
              </div>
            </div>
            {this.props.alerts.length >0 &&
              <div className="col-sm-6  form-group">
                <div className="card-data-cell remove-border-left">
                  <label>{i18next.t('form-labels.associated-alert-configurations')} ({this.props.alerts.length}):</label>
                  {alerts}
                </div>
              </div>
            }
          </div>
        </div>

        <div className="op-content-box">
          <h4 className="remove-margin-bottom">{i18next.t('pages.actions.header')}</h4>
          <div className="row">
            <div className="col-sm-12 col-md-6 oc-mini-card oc-mini-card-gray">
              <div className="inner">
                <div className="row">
                  <div className="col-sm-6"><label>{i18next.t('form-labels.type')}</label> <p>{i18next.t('log')}</p></div>
                </div>
              </div>
            </div>
            {actionResultRows}
          </div>
        </div>
      </div>
    );
  }
}

const ActionResultRow = (props) => {
  let valueView = null;
  if (props.actionResult.actionResultType.hasValue && props.actionResult.actionResultType.isRoleBased) {
    valueView = (<div className="col-sm-6"><label>{i18next.t('form-labels.distribution-group')}</label> <p>{props.actionResult.role.name}</p></div>);
  } else if (props.actionResult.actionResultType.hasValue) {
    valueView = (<div className="col-sm-6"><label>{i18next.t('form-labels.value')}</label> <p>{props.actionResult.value} <br/> {props.actionResult.locale.description}</p></div>);
  }
  return (
      <div className="col-sm-12 col-md-6 oc-mini-card oc-mini-card-gray">
        <div className="inner">
          <div className="row">
            <div className="col-sm-6"><label>{i18next.t('form-labels.type')}</label> <p>{i18next.t(`action-result-types.${props.actionResult.actionResultType.token}`)}</p></div>
            {valueView}
          </div>
        </div>
      </div>
  );
};

export default ActionView;
